<template>
    <div class="container-fluid" >
        <div class="row justify-content-center">
            <div class="text-center col">
                <div class="input-group pushdown d-none d-lg-flex">
                    <input type="text" class="form-control" placeholder="Dein Name" aria-label="Dein Name" aria-describedby="uploadgroup" v-model="name" @blur="nameChanged">
                    <input type="text" class="form-control" placeholder="Nachricht (z. B. Aufgabentext)" aria-label="Deine Nachricht" aria-describedby="uploadgroup" v-model="text">
                    <div class="input-group-append" id="uploadgroup">
                        <button class="btn btn-secondary" type="button" @click="selectPictures">Galerie</button>
                        <button class="btn btn-secondary" type="button" @click="takePicture">Kamera</button>
                        <button class="btn btn-primary" type="button" @click="upload" :disabled="pending.length <= 0">{{ buttonText }}</button>
                    </div>
                </div>
                <div class="d-lg-none pushdown">
                    <div class="input-group wfifty">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="name">Name</span>
                        </div>
                        <input type="text" class="form-control" placeholder="Dein Name" aria-label="Dein Name" aria-describedby="uploadname" v-model="name" @blur="nameChanged">
                    </div>
                    
                    <div class="input-group wfifty">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="name">Nachricht</span>
                        </div>
                        <input type="text" class="form-control" placeholder="z. B. Aufgabentext" aria-label="Dein Name" aria-describedby="uploadtext" v-model="text">
                    </div>
                    
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" class="btn btn-secondary" @click="selectPictures">Galerie</button>
                        <button type="button" class="btn btn-secondary" @click="takePicture">Kamera</button>
                        <button type="button" class="btn btn-primary" @click="upload" :disabled="pending.length <= 0">{{ buttonText }}</button>
                    </div>
                </div>
                <p v-if="pictures.length === 0" class="weak"><small>Hier könnt ihr eure Eindrücke oder die Fotoaufgaben hochladen.</small></p>
            </div>
        </div>

        <div class="row">
            <div class="col-6 eurebilder-l">
                <template v-for="p in pictures.slice(0, limit).filter((x, i) => i%2 === 0)">
                    <img :src="`${p}?xon=${uid}`" alt="" :key="p">
                </template>
            </div>
            <div class="col-6 eurebilder-r">
                <template v-for="p in pictures.slice(0, limit).filter((x, i) => i%2 === 1)">
                    <img :src="`${p}?xon=${uid}`" alt="" :key="p">
                </template>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="text-center col">
                {{ loadMore }}<br><br>
                <button v-if="loadMore.length > 0" @click="increaseLimit" type="button" class="btn btn-outline-primary">Mehr laden</button>
            </div>
        </div>

        <div class="hidden-input">
            <input @change="filesChanged" type="file" accept="image/*" ref="files" multiple="multiple" id="bilder" name="bilder" class="custom-file-input">
            <input @change="filesChanged" type="file" accept="image/*" ref="camera" multiple="multiple" id="kamera" name="kamera" capture="camera" class="custom-file-input">
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'bilder',
    data() {
        return {
            uid: null,
            pictures: [],
            pending: [],
            uploading: -1,
            name: '',
            text: '',
            limit: 20
        }
    },
    computed: {
        buttonText() {
            if (this.$data.uploading >= 0) {
                return `Sende Bild ${this.$data.uploading + 1} von ${this.$data.pending.length}`
            }

            if (this.$data.pending.length) {
                return `${this.$data.pending.length} Bilder hochladen`
            }

            return "Nichts ausgewählt"
        },
        loadMore() {
            if (this.$data.pictures.length > this.$data.limit) {
                return `Und ${this.$data.pictures.length - this.$data.limit} weitere Bilder`
            }

            return ''
        }
    },
    methods: {
        nameChanged() {
            localStorage.setItem('name', this.$data.name)
        },
        increaseLimit() {
            this.$data.limit += 20
        },
        takePicture() {
            this.$refs.camera.click()
        },
        selectPictures() {
            this.$refs.files.click()
        },
        filesChanged() {
            this.$data.pending = [...this.$refs.files.files, ...this.$refs.camera.files]
        },
        upload() {
            const _ = this

            this.$data.uploading = 0

            function next() {
                const item = _.$data.pending[_.$data.uploading]

                fetch('/api/pictures/', {
                    method: 'POST',
                    headers: {
                        'X-Owner-Name': _.$data.uid,
                        'X-Data-Name': _.$data.name,
                        'X-Data-Desc': _.$data.text
                    },
                    body: item
                })
                .then(r => r.json())
                .then(r => {
                    _.$data.pictures.push(r.uri)
                    
                    if(_.$data.uploading + 1 === _.$data.pending.length) {
                        setTimeout(() => {
                            _.$data.uploading = -1
                            _.$data.pending = []
                            _.$refs.files.value = ""
                            _.$refs.camera.value = ""
                        }, 1000)
                    } else {
                        _.$data.uploading += 1
                        next()
                    }
                })
            }

            next()
        }
    },
    mounted() {
        // uid
        let uid = localStorage.getItem('uid')

        if (!uid) {
            uid = uuidv4()
            localStorage.setItem('uid', uid)
        }

        this.$data.uid = uid

        // name
        let name = localStorage.getItem('name')
        if (name) {
            this.$data.name = name
        }

        // fetch images
        const _ = this

        fetch('/api/pictures', {
            headers: {
                'X-Owner-Name': this.$data.uid
            }
        })
        .then(r => r.json())
        .then(r => {
            if (r && r.length) {
                _.$data.pictures = []
                _.$data.pictures.push(...r)
            }
        })
    }
}
</script>

<style lang="scss">
@import '~bootstrap';

.hidden-input {
    visibility: collapse;
}

.thin {
    font-weight: 300;
}

.pushdown {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.wfifty {
    width: 80% !important;
    margin-bottom: 1rem;
    //transform: translateX(10%);
    margin-left: 10%;
    margin-right: 10%;

    & > div {
        width: 5rem;

        & > * {
            width: 5rem;
        }
    }
}

@include media-breakpoint-down (md) {
    .eurebilder-l img {
        margin: 0 0 1rem 0;
        width: 100%;
    }

    .eurebilder-r img {
        margin: 0 0 1rem 0;
        width: 100%;
    }

    .floatinggroup {
        position: fixed !important;
        left:50%;
        right:50%;
        bottom: 1rem;
        z-index: 4;

        & div {
            box-shadow: 0px 0px 6px 2px rgba(30, 30, 30, 0.5);
            border-radius: 4px;
        }
    }
}

@include media-breakpoint-up (lg) {
    .eurebilder-l img {
        margin: 0 0 1rem 0;
        width: 100%;
    }

    .eurebilder-r img {
        margin: 0 1rem 1rem 0;
        width: 100%;
    }

    .floatinggroup {
        position: absolute !important;
        left:50%;
        right:50%;
        bottom: 1rem;
        z-index: 4;

        & div {
            box-shadow: 0px 0px 6px 2px rgba(30, 30, 30, 0.5);
            border-radius: 4px;
        }
    }
}
</style>